var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWaterDistributionNetwork(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 58,
    viewBox: "0 0 59 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2679_1169)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.9896 0H11.0104C4.9295 0 0 4.84595 0 10.8237V47.1763C0 53.154 4.9295 58 11.0104 58H47.9896C54.0705 58 59 53.154 59 47.1763V10.8237C59 4.84595 54.0705 0 47.9896 0Z",
    fill: "#7AE2FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.438 45.4717C28.565 45.4717 27.8574 44.7761 27.8574 43.9179V15.1563C27.8574 14.2982 28.565 13.6025 29.438 13.6025C30.3109 13.6025 31.0185 14.2982 31.0185 15.1563V43.9179C31.0185 44.7761 30.3109 45.4717 29.438 45.4717Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3896 20.6317C23.9988 21.1894 24.9454 21.1814 25.5447 20.6134L29.4345 17.0153L33.0411 20.6109C33.641 21.1753 34.5846 21.1817 35.1922 20.6254L35.193 20.6246C35.8444 20.0282 35.8601 19.0189 35.2277 18.4032L29.4345 12.5278L23.352 18.4131C22.7223 19.0293 22.7394 20.0364 23.3896 20.6317Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3117 21.0386H24.4211L24.3652 18.4123L34.3117 18.3574V21.0386Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.7978 26.5254L45.7202 31.5736C45.4576 31.8316 45.1118 31.9638 44.766 31.9638C44.4012 31.9638 44.0426 31.819 43.78 31.5421C43.5495 31.2967 43.4343 30.9946 43.4279 30.6861V28.1368H39.1059C38.6513 28.1368 38.2863 28.5018 38.2863 28.9426V39.8258C38.2863 40.6817 37.5755 41.3805 36.7047 41.3805C35.8274 41.3805 35.123 40.6817 35.123 39.8258V28.9426C35.123 26.7834 36.9095 25.0272 39.1059 25.0272H43.4279V22.4403C43.4279 22.4214 43.4279 22.3962 43.4343 22.3773C43.4407 22.0752 43.5559 21.773 43.7865 21.5402C44.3051 20.9925 45.1887 20.9799 45.7265 21.5087L50.7978 26.5254Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.20118 26.5254L13.2787 31.5736C13.5414 31.8316 13.8872 31.9638 14.2329 31.9638C14.5978 31.9638 14.9564 31.819 15.219 31.5421C15.4495 31.2967 15.5647 30.9946 15.5711 30.6861V28.1368H19.8931C20.3477 28.1368 20.7127 28.5018 20.7127 28.9426V39.8258C20.7127 40.6817 21.4235 41.3805 22.2943 41.3805C23.1716 41.3805 23.8759 40.6817 23.8759 39.8258V28.9426C23.8759 26.7834 22.0895 25.0272 19.8931 25.0272H15.5711V22.4403C15.5711 22.4214 15.5711 22.3962 15.5647 22.3773C15.5583 22.0752 15.443 21.773 15.2125 21.5402C14.6939 20.9925 13.8102 20.9799 13.2725 21.5087L8.20118 26.5254Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4341 22.3774C43.4277 22.3963 43.4277 22.4215 43.4277 22.4405V22.3774H43.4341Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2679_1169"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 59,
    height: 58,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaterDistributionNetwork);
export default __webpack_public_path__ + "static/media/water-distribution-network.14d28b7b8f19958bea0c5b93a420bf3e.svg";
export { ForwardRef as ReactComponent };